import type { RenderProps } from 'hb-builder/components/common/type/RenderProps';
import {
  useRenderComponentsContext,
  useRendererContext,
} from 'hb-builder/hooks';
import type { RenderComponent } from 'hb-builder/types';
import type { DocumentItem } from 'hb-react/backoffice/types/builder/builderDocument';
import type { HeroItemAttributes } from 'hb-react/backoffice/types/builder/itemAttributes/heroItemAttributes';

const Hero: RenderComponent = () => <div />; // never used

const Render = ({
  children,
  item,
}: RenderProps<DocumentItem<HeroItemAttributes>>) => {
  const rendererContextValue = useRendererContext();
  const { components } = useRenderComponentsContext();

  const { Section } = components;

  return (
    <Section.Render
      components={components}
      item={item}
      {...rendererContextValue}
    >
      {children}
    </Section.Render>
  );
};

Hero.componentName = 'Hero';
Hero.Render = Render;

export default Hero;
